import React, { useState, useEffect } from 'react'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { doneLoading, startLoading } from '../../utils/loading'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import SubProjectSubmitProposl from '../../widgets/subProject/SubProjectSubmitProposl'
import { ERR_MSG_404_PROJECT_ID } from '../../constants/msgText'
import { SUB_PROJECT_ID } from '../../constants/constants'
import { sessionGetItemStr } from '../../utils/sessionHelpers'
import { getSubmitSubProject } from '../../redux/actions/subProjectManage'
import ContentHeaderWidget from '../../components/ContentHeader/ContentHeaderWidget'

export default function SubmitProposal() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()

  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  useEffect(() => {
    if (subProjectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      // const _schema = mockSchema //await getSubmitSubProject(subProjectId)
      const _schema = await getSubmitSubProject(subProjectId)
      setSchema(_schema)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProject>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          <SubProjectSubmitProposl schema={schema.forms.projectSubmit} />
        </SidebarProposal>
      )}
    </>
  )
}
